import React from 'react'
import { useViewport } from '../../utils';
import recharts from './recharts';
const {
  PieChart,
  Pie,
  Cell,
  Label
} = recharts

const DonutChartBig = ({data = [], total, colors}) => {
  const { isMobile } = useViewport()
  const size = isMobile ? 123 : 166
  const fontSize = isMobile ? '36px' : '48px'

  return (
    <div>
      <PieChart width={size} height={size}>
        <Pie
          data={data}
          cx={size/2.05}
          cy={size/2.05}
          innerRadius={size/2.6}
          outerRadius={size/2.1}
          fill="#8884d8"
          paddingAngle={2}
          dataKey="value"
        >
          {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />)
          }
          <Label width={30} position="center" style={{fontSize: fontSize}} className="font-primary">
            {total}
          </Label>
        </Pie>
      </PieChart>
      </div>
  )
}

export { DonutChartBig }
